// menu.js
const headerContent = document.getElementById("header-content");
const menuItemsWithChildren = document.querySelectorAll(".menu-item-has-children > a");
const submenuItems = document.querySelectorAll(".sub-menu");
const headerBackground = document.querySelector(".header-background");
const blur = document.getElementById("blur");

const hamburger = document.getElementById("hamburger");
const hamburgerIcon = hamburger.querySelector(".menu-open");
const closeIcon = hamburger.querySelector(".menu-close");

const nav = document.getElementById("nav");

// open submenu
function openSubmenu(menuItemWithChildren) {
  const submenu = this.nextElementSibling;

  // show submenu
  submenu.setAttribute("aria-expanded", "true");
  submenu.style.display = "block";
  menuItemWithChildren.setAttribute("aria-expanded", "true");

  // close other submenus
  submenuItems.forEach((item) => {
    if (item !== submenu) {
      item.setAttribute("aria-expanded", "false");
      item.style.display = "none";

      // set all menu items to aria-expanded="false"
      menuItemsWithChildren.forEach((item) => {
        if (item !== this) {
          item.setAttribute("aria-expanded", "false");
        }
      });
    }
  });

  // show corresponding menu image
  let liNumber = Array.from(this.parentElement.parentElement.children).indexOf(this.parentElement);
  liNumber = liNumber + 1;

  // hide all menu images
  document.querySelectorAll(".nav-image").forEach((image) => {
    image.style.opacity = "0";
  });

  // show menu image
  let menuImage = document.getElementById("nav-image-" + liNumber);

  // append menu image in corrsponding li
  if (menuImage !== null) {
    this.parentElement.appendChild(menuImage);
    // show the image
    menuImage.style.opacity = "1";
    menuImage.style.pointerEvents = "auto";
  }

  // set header background height
  let submenuHeight = submenu.offsetHeight + 48;
  headerBackground.style.height = `${submenuHeight}px`;

  if (submenuHeight < 472 && menuImage !== null) {
    headerBackground.style.height = "472px";
  }

  // show blur
  blur.style.opacity = ".2";
}

// hide submenu
function hideSubmenu() {
  submenuItems.forEach((item) => {
    item.setAttribute("aria-expanded", "false");
    item.style.display = "none";
  });

  menuItemsWithChildren.forEach((item) => {
    item.setAttribute("aria-expanded", "false");
  });

  // hide all menu images
  document.querySelectorAll(".nav-image").forEach((image) => {
    image.style.opacity = "0";
    image.style.pointerEvents = "none";
  });

  // decrease size of header background
  headerBackground.style.height = "100%";

  // hide blur
  blur.style.opacity = "0";
}

// loop through each menu item with children
menuItemsWithChildren.forEach((item) => {
  // add aria-expanded attribute to each menu item
  item.setAttribute("aria-expanded", "false");

  // add click event to each menu item with children
  item.addEventListener(show_submenu_on, function (event) {
    event.preventDefault();
    openSubmenu.call(this, item);
  });
});

// hide submenu when mouse leaves header content
headerContent.addEventListener("mouseleave", () => {
  hideSubmenu();
});

// hide submenu when scroll
window.addEventListener("scroll", () => {
  // if window > 1024 hide submenu
  if (window.innerWidth > 1024) {
    hideSubmenu();
  }
});

// hide submenu when window resizes
window.addEventListener("resize", () => {
  hideSubmenu();
});

// hide submenu of focus is on li without children
document.addEventListener(
  "focus",
  function (event) {
    if (!event.target.closest(".menu-item-has-children")) {
      hideSubmenu();
    }
  },
  true
);

// open menu with hamburger
hamburger.addEventListener("click", () => {
  // show nav
  headerContent.classList.toggle("open");
  nav.classList.toggle("open");

  // toggle the hidden class
  hamburgerIcon.classList.toggle("hidden");
  closeIcon.classList.toggle("hidden");

  // toggle class on html
  document.documentElement.classList.toggle("no-scroll");
});
